import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import smsService from "../../../api/reservePlanNew.service";
import telematicsService from "../../../api/telematics.service";
import schedulerDialog from "@/components/SchedulerDialog";

import rules from "../../../utils/rules";
import moment from "moment";
export default {
  name: "on-rent-with-cost-analysis",
  components: { pageheader, schedulerDialog },
  data() {
    return {
      input: {},
      loadergetcalls: false,
      rules: rules,
      search: "",
      menu1: false,
      menu2: false,
      isReportExporting: false,
      showTable: false,
      reportsList: [],

      filterTypes: [
        { id: "2", name: "Equipment" },
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "7", name: "Search Field" },
      ],

      selectedZone: [],
      zonesList: [],
      modelSearchFilter: "",
      models: [],
      selectedModel: [],
      searchMenu: false,
      searchEquipName: "",
      searchPO: "",
      searchJob: "",
      searchContractId: "",
      nodataMachine: false,
      showmachinmsg: true,
      fromDate: "",
      toDate: new Date().toISOString().slice(0, 10),

      header: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        { text: "Equipment #", value: "itemKey", width: "150px" },
        { text: "Equipment", value: "itemName", width: "200px" },
        {
          text: "Telematics SN",
          value: "telematicsDeviceSN",
          width: "200px",
        },
        { text: "Customer Name", value: "customerName", width: "200px" },
        { text: "Contract #", value: "cntr" },
        { text: "Contract Status", value: "contractStatus" },

        { text: "Qty", value: "qty" },
        { text: "Item Status", value: "itemStatus" },
        { text: "Date Out", value: "dateOut" },
        { text: "Due Due", value: "dateDue" },
        { text: "Daily Rate", value: "dailyAmount" },
        { text: "Weekly Rate", value: "weeklyAmount" },
        { text: "Monthly Rate", value: "monthlyAmount" },
        { text: "Spend to Date", value: "costToDate" },
        {
          text: "Estimated Remaining Spend",
          value: "estTotalCost",
          width: "150px",
        },
        { text: "Days On Rent", value: "daysOnRent" },

        { text: "Jobsite", value: "jobsite", width: "200px" },
        { text: "Job #", value: "jobNo" },
        { text: "PO #", value: "pono", width: "100px" },
        { text: "Ordered By", value: "orderBy" },
        { text: "Picked Up By", value: "pickedUpBy" },
        { text: "Last GPS Address", value: "lastGPSAddress" },
      ],
      smsCustomersList: [],
      selectedSMSCustomer: "",
      isCustLoad: false,
      csvName: "On Rent With Spend Analysis.xlsx",
      pdfName: "On Rent With Spend Analysis.pdf",
      isDownloadCSV: false,
      errorMSG: "Please select customer to run the report",
      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",
      searchemail: null,
      emailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },
        { text: "Name", value: "name", width: "10px" },
        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },
        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel", "PDF"],
      scheduledType: "",
      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      machineSearchFilterSchedule: null,
      groupSearchFilterSchedule: "",
      accessControlCodesSearchFilterSchedule: "",
      selectedOwnershipTypeSchedule: ["1", "2"],
      selectedOwnershipFinalSchedule: "",
      searchFieldSchedule: "",
      searchSchedule: "",
      ScheduleReportName: "ONRENTCOSTANALYSIS",
      searchMenuSchedule: false,
      selectedschedule: {},
      scheduleedit: false,
      dailyUtilizationTargetSchedule: 0,
      selectedTimeSchedule: "Hours",
      selectedZonesNamesSchedule: [],
      selectedJobSiteNamesSchedule: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedMachineSchedule: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      scheduleformvalid: true,
      isSaveScheduleLoading: false,
      isupdateScheduleLoading: false,
      scheduleName: "",
      selectedcust: "",
      scheduledList: [],
      isScheduledListLoading: false,
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],

      selectedDays: [],
      custnum: "",
      custid: "",
      isRefreshingData: false,
      groupSearchFilter: "",
      jobSiteList: [],
      groups: [],
      selectedGroup: [],
      selectedExportOption: null,
      exportOptions: ["Excel", "PDF"],
      closeOnContentClick: false,
      // end scheduled reports data fields
      zoneSearchFilter: "",
      selectedJobSiteNames: [],
      loadingMachines: false,
      isReportLoading: false,

      selected: [
        "Equipment",
        "Daily Utilization Target",
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Access Control Codes",
        "Owner Type",
        "Search Field",
      ],
      selectedMachine: [],
      selectedMachineCount: "",
      machines: [],
      loadinglocations: false,
      locations: [],
      machineSearchFilter: null,
      selectedJobSite: [],
      jobSiteSearchFilter: "",
      loading: false,
      searchField: "",
      searchField1: "",
      isDownloading: false,
      menufilter: false,
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "smsCustomerLinkingId",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  watch: {
    machineSearchFilter(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
    machineSearchFilterSchedule(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  async mounted() {
    this.input = utils.getInputContent(
      "rentWithCostAnalaysisReport",
      this.roles
    );

    if (
      this.companyNameDropdown !== "All" &&
      this.companyNameDropdown !== undefined &&
      this.companyNameDropdown !== ""
    ) {
      this.getReportList();
      this.loadergetcalls = false;

      await this.getGroups();
      await this.getLocations();
      await this.getModels();
      await this.getZones();
      this.loadergetcalls = true;

      //load the report on page load as it doesn't have any filters
    }
  },
  methods: {
    mindate() {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1))
        .toISOString()
        .slice(0, 10);
    },
    maxdate() {
      return new Date().toISOString().slice(0, 10);
    },
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    async getReportList(isRefresh) {
      if (isRefresh) {
        this.isRefreshingData = true;
        this.reportsList = [];
      } else {
        this.isReportLoading = true;
      }
      try {
        let response = await smsService.getOnRentWithCostAnalysisReport(
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response.isSuccess && response.data.length >= 0) {
          this.showTable = true;
          this.reportsList = response.data;
          this.isReportLoading = false;
          this.isRefreshingData = false;
        } else {
          this.reportsList = [];
          this.isReportLoading = false;
          this.isRefreshingData = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
        this.isRefreshingData = false;
      }
    },
    clearFilters() {
      this.reportsList = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.selectedJobSiteNames = [];
      this.searchEquipName = "";
      this.searchPO = "";
      this.searchJob = "";
      this.searchContractId = "";
      this.getReportList();
    },
    async downloadReport(exportOption) {
      try {
        let response = await smsService.exportOnRentWithCostAnalysisReport(
          exportOption,
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response) {
          if (exportOption == this.exportOptions[0]) {
            //excel
            utils.downloadExcelFile(response, this.csvName);
          } else {
            //pdf
            utils.downloadPDFFile(response, this.pdfName);
          }
        } else {
          this.$toast.error(
            "Unable to download the report. Please contact admin."
          );
        }
        this.isDownloading = false;
      } catch (error) {
        this.$toast.error(
          "Unable to download the report. Please contact admin."
        );
        this.isDownloading = false;
      }
    },
    // scheduled reports api calls
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    showScheduledForm() {
      this.scheduleedit = false;
      this.clearSchedule();
      this.displayScheduledForm = true;
    },
    cancelSchedule() {
      this.displayScheduledForm = false;
      this.scheduleedit = false;

      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledtimeframe = "";
      this.scheduledType = "";

      this.searchFieldSchedule = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    closeSchedule() {
      this.scheduledialog = false;
      this.clearSchedule();
    },
    clearSchedule() {
      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledtimeframe = "";
      this.scheduledType = "";
      this.searchFieldSchedule = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    openScheduledDialog() {
      this.$refs.modal.showScheduleModal();
    },

    // end scheduled reports methods
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.downloadReport(this.exportOptions[0]);
        } else if (this.selectedExportOption == this.exportOptions[1]) {
          //case  "Pdf"
          this.downloadReport(this.exportOptions[1]);
        }
      }
    },
    async searchMachines(value) {
      let machineValue = "";
      machineValue = encodeURIComponent(value);
      this.machines = [];
      try {
        this.loading = true;
        let response = await telematicsService.getTelematicMachinesnew(
          machineValue
        );
        if (response && response.data.length != 0) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });
          this.loading = false;
        } else {
          this.nodataMachine = true;
          this.showmachinmsg = false;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.nodataMachine = true;
        this.showmachinmsg = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = this.locations = response.data.filter(
            (e) => e.locationName != null
          );
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getJobSites() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = response.data.filter(
            (e) => e.locationName != null
          );
        } else {
          this.jobSiteList = [];
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
    },
    resetGroup() {
      this.selectedGroup = [];
    },
    resetMachine() {
      this.selectedMachine = [];
    },
    resetZone() {
      this.selectedZone = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
      this.jobSiteChange();
    },
    resetModel() {
      this.selectedModel = [];
    },
    clearSearchEquipName() {
      this.searchEquipName = "";
    },
    clearSearch() {
      this.searchPO = "";
    },
    clearSearchJob() {
      this.searchJob = "";
    },
    clearSearchContractId() {
      this.searchContractId = "";
    },
    zoneChange() {
      this.selectedZonesNames = [];
      this.selectedZonesNames = this.selectedZone.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    modelChange() {
      this.selectedModelNames = [];
      this.selectedModelNames = this.selectedModel.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    jobSiteChange() {
      this.selectedJobSiteNames = [];
      this.selectedJobSiteNames = this.selectedJobSite.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
  },
};
